import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  const getCategoryName = (slug: string) => {
    return categories.find((c) => c.slug === slug)?.name || '';
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              精选攻略
            </h2>
            <p className="text-sm text-foreground-600">
              经过编辑部精挑细选的高质量攻略文章，每一篇都值得反复阅读
            </p>
          </div>
          <Link
            to="/category/hebing-celue"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs px-2.5 py-1 bg-primary-100 text-primary-700 rounded-md font-medium whitespace-nowrap">
                    {getCategoryName(article.categorySlug)}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                    阅读全文
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/hebing-celue"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium"
          >
            查看全部攻略
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}